export const transformProductsData = (shopifyProducts) => {
  if (!shopifyProducts) return [];

  return shopifyProducts
    .filter(product => product.node.onlineStoreUrl)
    .map(product => {
      const variant = product.node.variants.edges[0].node;
      const regularPrice = +variant.compareAtPrice || +variant.price;
      const salePrice = (variant.compareAtPrice && variant.compareAtPrice !== variant.price) ? +variant.price : null;

      return {
        href: `${product.node.onlineStoreUrl}?search`,
        picture: {
          src: product.node.featuredImage?.url,
          alt: product.node.title
        },
        vendor: product.node.vendor,
        title: product.node.title,
        price: {
          regular: regularPrice,
          sale: salePrice,
          currency: 'PLN'
        }
      };
    })
    .slice(0, 30);
};
